import styled from 'styled-components';

export const Box = styled.div`
  position: fixed;
  bottom: ${({ theme }) =>
    theme.isWebView ? 'calc(env(safe-area-inset-bottom) + 15px)' : '15px'};
  right: 15px;
  left: 15px;
  display: flex;
  justify-content: space-between;
  gap: 10px;
  z-index: 10010;
`;
